import { enqueueSnackbar } from "notistack"
import { useEffect } from "react"
import { useHistory } from "react-router"
import {
  getExitingImpersonationFlag,
  getOriginalUserData,
  removeExitingImpersonationFlag,
  removeOriginalUserData,
  setCurrentUserForImpersonationLogin
} from "../helpers/impersonationStorageManage"

// Hook for login to the original account
export const useExitingImpersonationManage = (args: { isAuthed: boolean }) => {
  const { isAuthed } = args

  const history = useHistory()

  useEffect(() => {
    // Get flag value for checking: is it login from impersonated user to the original user
    const isExitingImpersonation = getExitingImpersonationFlag()
    // Get original user's data
    const originalUserData = getOriginalUserData()

    // If we are on the account and `isExitingImpersonation` is equal to true ->
    // we should remove this flag and original user data from storage
    if (!!isAuthed && !!isExitingImpersonation) {
      removeExitingImpersonationFlag()
      removeOriginalUserData()

      // Move to last url of original user before his moving to the impersonation
      history.replace(originalUserData.backUrl)

      enqueueSnackbar("Impersonation ended. You’re back in your account.", {
        variant: "success",
        autoHideDuration: 10000
      })

      return
    }

    // // Return from hook if we are authed
    // // or `isExitingImpersonation` flag is equal to false
    if (!!isAuthed || !isExitingImpersonation) {
      return
    }

    if (!originalUserData?.authUrl) {
      enqueueSnackbar(
        "An error occurred while trying to leave impersonation. Please try again. If the error persists, contact support for help",
        {
          variant: "error",
          autoHideDuration: 10000
        }
      )
    }

    // Setting original user's data to `user` storage value for correct login
    setCurrentUserForImpersonationLogin(originalUserData)

    // Move to the `auth/token` page for login by token
    history.replace(originalUserData.authUrl)
  }, [isAuthed])
}
